import { render, staticRenderFns } from "./DataPage.vue?vue&type=template&id=e7e0ec14&"
import script from "./DataPage.vue?vue&type=script&lang=js&"
export * from "./DataPage.vue?vue&type=script&lang=js&"
import style0 from "./DataPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports